import { z } from 'zod';

export const aiSearchSchema = z.object({
	filters: z.string().min(1, 'Please provide a prompt to start to search')
});

export type AiSearchSchemaProps = z.infer<typeof aiSearchSchema>;
